import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppUpdate, AppUpdateInfo } from '@capawesome/capacitor-app-update';
import { IonModal } from '@ionic/angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})


export class AppComponent {

  public userData: any = [];
  public name: string = '';
  public email: string = '';
  private just: any;
  private active: any;
  public menu_logbook: any = {};
  public appPages;
  public appPagesMenuLogbook;
  private logbook_list: any;

  public currentAppVersion: string = "";
  public availableAppVersion: string = "";
  @ViewChild("updateModal") updateModal: IonModal;

  constructor(
    private router: Router
  ) {
  }

  todo = {
    name: 'Staff Febrasgo',
    email: 'gerencia@febrasgo.org.br'
  };

  ngAfterViewInit()
  {
    this.checkForUpdates();
  }


  ngOnInit() {
    this.userData = JSON.parse(window.localStorage.getItem("userData"));
    if (this.userData !== null) {
      this.todo.name = this.userData.name;
      this.todo.email = this.userData.email;
    }
    // console.log(this.todo.name, this.todo.email)

    let data_storage = localStorage.getItem("userData");
    if (data_storage !== null) {
      let user = JSON.parse(data_storage);
      this.just = user.just ?? "associated";
      this.active = user.active;

      if(user.logbook_list) {
        this.logbook_list = true;
      } else {
        this.logbook_list = false;
      }

      let arr_category = [3, 5, 9, 77, 78, 79, 83];
      if (arr_category.indexOf(user.category_id) > -1 == true || (user.just == 'supervisor_associated' || user.just == 'preceptor_supervisor_associated') ) {
        if((user.just == 'residente_associated' || user.just == 'residente') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-procedimentos', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'preceptor_associated' || user.just == 'preceptor') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-procedimentos-vinculados', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'supervisor_associated' || user.just == 'supervisor') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-preceptores-vinculados', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'preceptor_supervisor_associated' || user.just == 'preceptor_supervisor') && (this.active == '1' || (user.supervisor && user.supervisor.active == '1'))) {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-preceptores-e-procedimentos-vinculados', type: 'internal', icon: 'bag-add' }        
        }
      } else {
        if((user.just == 'residente_associated' || user.just == 'residente') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-procedimentos', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'preceptor_associated' || user.just == 'preceptor') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-procedimentos-vinculados', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'supervisor_associated' || user.just == 'supervisor') && this.active == '1') {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-preceptores-vinculados', type: 'internal', icon: 'bag-add' }        
        }

        if((user.just == 'preceptor_supervisor_associated' || user.just == 'preceptor_supervisor') && (this.active == '1' || (user.supervisor && user.supervisor.active == '1'))) {
          this.menu_logbook = { title: 'Logbook', url: '/logbook-preceptores-e-procedimentos-vinculados', type: 'internal', icon: 'bag-add' }        
        }
      }

      this.appPages = [
        { title: 'Home', url: '/home', type: 'internal', icon: 'lock-closed' },
        this.menu_logbook,
        { title: 'Notícias', url: '/noticias', type: 'internal', icon: 'list' },
        { title: 'Eventos', url: '/eventos', type: 'internal', icon: 'bookmark' },
        { title: 'Revistas', url: '/revistas', type: 'internal', icon: 'book' },
        this.userData.status != 'defaulting' ? { title: 'Protocolos', url: '/protocolo', type: 'internal', icon: 'create' } : '',
        { title: 'Concursos', url: '/concursos', type: 'internal', icon: 'ribbon' },
        { title: 'Febrasgo EAD', url: '', type: 'external', icon: 'desktop' },
        { title: 'Febrasgo Position Statement', url: '/position', type: 'internal', icon: 'book' },
        this.userData.status != 'defaulting' ? { title: 'Orientações e Recomendações', url: '/orientacoes', type: 'internal', icon: 'pencil' } : '',
        this.userData.status != 'defaulting' ? { title: 'Consentimento Informado', url: '/termos', type: 'internal', icon: 'newspaper' } : '',
        { title: 'Calculadoras', url: '/calculadoras', type: 'internal', icon: 'calculator' },
        this.userData.status != 'defaulting' ? { title: 'Fluxogramas', url: '/fluxogramas', type: 'internal', icon: 'git-network' } : '',
        { title: 'Links Úteis', url: '/linksuteis', type: 'internal', icon: 'open' },
        { title: 'Códigos e Procedimentos', url: '/codigos-procedimentos', type: 'internal', icon: 'pulse' },
        { title: 'Busca Geral', url: '/busca-geral', type: 'internal', icon: 'search' },
        { title: 'Guia de Uso do APP', url: '/guia', type: 'internal', icon: 'school' },
        { title: 'Conheça nossas Federadas', url: 'https://www.febrasgo.org.br/pt/institucional/federadas', type: 'external', icon: 'open' },
        { title: 'Sair', url: '', type: 'internal', icon: 'log-out', click: this.logout }
      ];

      this.appPagesMenuLogbook = [
        { title: 'Home', url: '/home', type: 'internal', icon: 'lock-closed' },
        this.menu_logbook,
        { title: 'Códigos e Procedimentos', url: '/codigos-procedimentos', type: 'internal', icon: 'pulse' },
        { title: 'Calculadoras', url: '/calculadoras', type: 'internal', icon: 'calculator' },
        { title: 'Links Úteis', url: '/linksuteis', type: 'internal', icon: 'open' },
        { title: 'Guia de Uso do APP', url: '/guia', type: 'internal', icon: 'school' },
        { title: 'Sair', url: '', type: 'internal', icon: 'log-out', click: this.logout }
      ];
    }
  }

  checkForUpdates()
  {
    AppUpdate.getAppUpdateInfo().then((data: AppUpdateInfo) => {
        this.currentAppVersion = data.currentVersion;
        this.availableAppVersion = data.availableVersion;

        if(parseFloat(this.availableAppVersion) > parseFloat(this.currentAppVersion)){
            setTimeout(() => {
                this.updateModal.present();
            }, 1500);
        }
    });
  }

  updateApp()
  {
    AppUpdate.openAppStore();
  }

  dismissUpdate()
  {
    this.updateModal.dismiss();
  }

  logout() {
    localStorage.removeItem("userData");
    // this.router.navigateByUrl("/login");
    window.location.href = "/login";
  }
}
